export default __webpack_public_path__ + "static/media/Pic6.ecf640c7.PNG";